import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { routes } from "./routes";
import "./index.css";

function renderRoutes(items: typeof routes) {
  return items.map((r, i) => {
    if ("index" in r && r.index) {
      return <Route key={i} index element={r.element} />;
    }
    return (
      <Route key={r.path ?? i} path={r.path} element={r.element}>
        {r.children ? renderRoutes(r.children as typeof routes) : null}
      </Route>
    );
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <BrowserRouter>
      <Routes>{renderRoutes(routes)}</Routes>
    </BrowserRouter>
  </HelmetProvider>,
);
